import { RequestCustomFieldAppModel, useSession } from '@api';
import { DrawerDetail } from '@common/ui/DrawerDetail/DrawerDetail';

type CustomField = { [key: string]: string };

export function RequestCustomFields({ customFields }: { customFields: CustomField }) {
  const { session } = useSession();
  if (!session) return null;

  return (
    <>
      {session.account_settings?.request_custom_fields.map((customField: RequestCustomFieldAppModel) => {
        const value = customFields[customField.id];
        if (!value) return null;
        return <DrawerDetail key={customField.id} label={customField.label} value={value} />;
      })}
    </>
  );
}
